import { redirectToErrorPage404, redirectToErrorPage500 } from '../utils/redirect.utils';

type ErrorCode = 'SERVER' | 'NOT_FOUND' ;
export const errorInterceptor = (errorCode: ErrorCode) => {
  if (errorCode === 'SERVER') {
    redirectToErrorPage500();
  }

  if (errorCode === 'NOT_FOUND') {
    redirectToErrorPage404();
  }

};

export const getCause = (status: number): ErrorCode => {
  if (status === 404) {
    return 'NOT_FOUND';
  }

  return 'SERVER';
}

